module.exports = __webpack_public_path__ + "static/media/dblog3.5c6615cb.jpg";